
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/category/create",
      function () {
        return require("private-next-pages/category/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/category/create"])
      });
    }
  